import React from 'react';
import { PlmProgramList } from './plmProgram-list';
// Update the import path below to the correct location if different
// Update the import path below to the correct location if different
import { useIsSmallScreen } from '../../../system/SystemMediaQueriesProvider';

export function PlmProgramMain() {
  const isSmall = useIsSmallScreen();

  return (
    <div
      style={{
        margin: isSmall ? '0px' : '10px',
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        alignItems: 'stretch',
      }}
    >
      <PlmProgramList />
    </div>
  );
}
